
import { RequestBase, RequestBasePageIds, RequestBaseSet, RequestDelete, RequestDeleteIds, ResponseBase, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { ValueOption } from "src/app/features/prob/models";

export class RequestValueOption extends RequestBasePageIds {

  /**
 * The identifier of the model value to filter value options by.
 */
  modelValueId?: string | null;

  /**
   * Indicates whether only active value options should be included.
   */
  isActive?: boolean | null;

  /**
   * Filter the search using text, code, tag id
   */
  filterSearch?: string | null;

}

export class ResponseValueOption extends ResponseBasePage<ValueOption> {
}

export class RequestValueOptionSet extends RequestBaseSet<ValueOption> {
}

export class ResponseValueOptionSet extends ResponseBaseSet<ValueOption> {
}
export class RequestValueOptionDelete extends RequestDeleteIds {

  hardDelete?: boolean | null;
}

export class RequestValueOptionSyncSet extends RequestBase {

  /**
   * The identifier of the model value to refresh sync any changes from the lookup table to the options.
   */
  modelValueId?: string | null;
  
}








